export const API_ROOT =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production"
    ? "https://www.alnarpsfarm.com/api"
    : "http://localhost:5050/api");
